
<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading"><svg width="42" height="27" viewBox="0 0 42 27" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_651_309)">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M32.3028 5.08326C31.7505 5.08326 31.3028 5.53097 31.3028 6.08326V17.5453H27.3636V0.999999C27.3636 0.447714 26.9158 0 26.3636 0H23.9696C23.4173 0 22.9696 0.447715 22.9696 1V17.5453H19.0304V11.5537C19.0304 11.0014 18.5827 10.5537 18.0304 10.5537H15.6364C15.0842 10.5537 14.6364 11.0014 14.6364 11.5537V17.5453H10.6913V8.07453C10.6913 7.52224 10.2436 7.07453 9.69133 7.07453H7.29738C6.74509 7.07453 6.29738 7.52224 6.29738 8.07453V17.5453H4V19H38V17.5453H35.7085V6.08326C35.7085 5.53097 35.2608 5.08326 34.7085 5.08326H32.3028Z"
                                fill="#265D91" />
                        </g>
                        <defs>
                            <filter id="filter0_d_651_309" x="0" y="0" width="42" height="27"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_651_309" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_651_309"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>


                    Evaluation
                </h1>
                <!--begin::Menu-->
            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a routerLink="/accueil" class="text-muted ">Accueil</a>
                  </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Evaluation</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Template Evaluation</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted"><a class="text-muted" routerLink="/evaluation/template-evaluation">Détail Evaluation</a></li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>

<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card pb-10 pt-10">

            <!--begin::Card header-->
            <div class="d-flex flex-wrap my-1 header-grid">
                <div class="section_title">
                    <h1 class="section-heading my-0">Détail template wegestu </h1>
                </div>

                <div class="add-template">

                    <!-- <a href="#" class="btn-add mr-2" data-bs-toggle="modal" data-bs-target="#ajouter">ajouter
                        question</a> -->

                </div>
            </div>
            <div class="card-body pt-15 ">
                <div class="content">
                    <div class="card-body pt-3">
                        <!--begin::Table-->
                        <div class="bloc-input mb-10">
                            <label for="nom" class="mb-2">Nom</label>
                            <input type="text" class="form-control" placeholder="Nom evaluation">
                        </div>
                        <div class="bloc-input mb-10">
                            <label for="type" class="mb-2">Type</label>
                            <ng-select
                            formControlName="type" [notFoundText]="'Aucun élément trouvé'"
                            [items]="type"
                            bindLabel="name"
                            bindValue="id">
                          </ng-select>
                        </div>
                      


                        <div class="actions">
                            <a href="#" class="annuler">Annuler</a>
                            <a class="confirmer">modifier</a>
                        </div>
                        <!--end::Table-->
                    </div>
                </div>



                <!--end::Table-->
            </div>
        </div>

        <!--end::Card header-->
        <!--begin::Card body-->
        <div class="card-body pt-15">
            <div class="container mt-15">
                <div class="evals">
                    <div class="eval mb-10" >

                        <h2>
                            Bloc 
                        </h2>

                        <div class="bloc mb-5">
                            <div class="text">
                                <span>1</span>
                                <p>trsjrsjrsjrj
                                </p>
                            </div>
                            <div class="edit">
                                <a href="#">
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g filter="url(#filter0_d_3561_441)">
                                            <path
                                                d="M4 15.6558V5.59137C4 4.9982 4.23707 4.42933 4.65906 4.00989C5.08106 3.59046 5.6534 3.35482 6.25019 3.35482H13.1301L10.9165 5.59137H6.25019V15.6558H16.376V11.0206L18.6262 8.82039V15.6558C18.6262 16.249 18.3891 16.8179 17.9671 17.2373C17.5451 17.6567 16.9728 17.8924 16.376 17.8924H6.25019C5.6534 17.8924 5.08106 17.6567 4.65906 17.2373C4.23707 16.8179 4 16.249 4 15.6558ZM20.3138 0C19.8664 0.000391512 19.4374 0.177375 19.1212 0.492041L11.1246 8.56878C10.8786 8.8174 10.6929 9.11861 10.5818 9.44942L9.77173 11.8677C9.76161 11.9064 9.76183 11.947 9.77238 11.9855C9.78293 12.0241 9.80343 12.0592 9.83185 12.0875C9.86028 12.1157 9.89564 12.1361 9.93443 12.1466C9.97322 12.1571 10.0141 12.1573 10.053 12.1473L12.4944 11.3505C12.8273 11.2401 13.1304 11.0556 13.3805 10.8109L21.5064 2.86278C21.7422 2.6282 21.9027 2.32944 21.9677 2.00425C22.0326 1.67906 21.9992 1.34202 21.8716 1.03569C21.744 0.729368 21.5279 0.4675 21.2507 0.283164C20.9734 0.098828 20.6474 0.000291618 20.3138 0Z"
                                                fill="#265D91" />
                                        </g>
                                        <defs>
                                            <filter id="filter0_d_3561_441" x="0" y="0" width="26" height="25.8923"
                                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                <feColorMatrix in="SourceAlpha" type="matrix"
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                    result="hardAlpha" />
                                                <feOffset dy="4" />
                                                <feGaussianBlur stdDeviation="2" />
                                                <feComposite in2="hardAlpha" operator="out" />
                                                <feColorMatrix type="matrix"
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                                <feBlend mode="normal" in2="BackgroundImageFix"
                                                    result="effect1_dropShadow_3561_441" />
                                                <feBlend mode="normal" in="SourceGraphic"
                                                    in2="effect1_dropShadow_3561_441" result="shape" />
                                            </filter>
                                        </defs>
                                    </svg>
                                </a>

                            </div>

                        </div>
                        <div class="line mb-10"></div>
                        <div class="rating">
                            <svg width="115" height="29" viewBox="0 0 115 29" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_3561_414)">
                                    <path
                                        d="M13.4974 2.92705C13.7968 2.00574 15.1002 2.00574 15.3995 2.92705L17.0188 7.91069C17.1527 8.32271 17.5366 8.60167 17.9699 8.60167H23.21C24.1787 8.60167 24.5815 9.84129 23.7977 10.4107L19.5584 13.4907C19.2079 13.7454 19.0613 14.1968 19.1951 14.6088L20.8144 19.5924C21.1138 20.5137 20.0593 21.2799 19.2756 20.7105L15.0362 17.6304C14.6858 17.3757 14.2112 17.3757 13.8607 17.6304L9.62134 20.7105C8.83762 21.2799 7.78314 20.5137 8.08249 19.5924L9.70178 14.6088C9.83565 14.1968 9.68899 13.7454 9.3385 13.4907L5.09917 10.4107C4.31546 9.84129 4.71823 8.60167 5.68695 8.60167H10.9271C11.3603 8.60167 11.7442 8.32271 11.8781 7.91069L13.4974 2.92705Z"
                                        fill="#FFD166" />
                                </g>
                                <g filter="url(#filter1_d_3561_414)">
                                    <path
                                        d="M35.0365 2.92705C35.3358 2.00574 36.6392 2.00574 36.9386 2.92705L38.5579 7.91069C38.6917 8.32271 39.0757 8.60167 39.5089 8.60167H44.749C45.7177 8.60167 46.1205 9.84129 45.3368 10.4107L41.0975 13.4907C40.747 13.7454 40.6003 14.1968 40.7342 14.6088L42.3535 19.5924C42.6528 20.5137 41.5984 21.2799 40.8146 20.7105L36.5753 17.6304C36.2248 17.3757 35.7502 17.3757 35.3997 17.6304L31.1604 20.7105C30.3767 21.2799 29.3222 20.5137 29.6216 19.5924L31.2408 14.6088C31.3747 14.1968 31.2281 13.7454 30.8776 13.4907L26.6382 10.4107C25.8545 9.84129 26.2573 8.60167 27.226 8.60167H32.4661C32.8994 8.60167 33.2833 8.32271 33.4172 7.91069L35.0365 2.92705Z"
                                        fill="#FFD166" />
                                </g>
                                <g filter="url(#filter2_d_3561_414)">
                                    <path
                                        d="M56.5794 2.92705C56.8788 2.00574 58.1822 2.00574 58.4815 2.92705L60.1008 7.91069C60.2347 8.32271 60.6187 8.60167 61.0519 8.60167H66.292C67.2607 8.60167 67.6635 9.84129 66.8798 10.4107L62.6404 13.4907C62.29 13.7454 62.1433 14.1968 62.2772 14.6088L63.8965 19.5924C64.1958 20.5137 63.1413 21.2799 62.3576 20.7105L58.1183 17.6304C57.7678 17.3757 57.2932 17.3757 56.9427 17.6304L52.7034 20.7105C51.9197 21.2799 50.8652 20.5137 51.1645 19.5924L52.7838 14.6088C52.9177 14.1968 52.771 13.7454 52.4205 13.4907L48.1812 10.4107C47.3975 9.84129 47.8003 8.60167 48.769 8.60167H54.0091C54.4423 8.60167 54.8263 8.32271 54.9601 7.91069L56.5794 2.92705Z"
                                        fill="#FFD166" />
                                </g>
                                <g filter="url(#filter3_d_3561_414)">
                                    <path
                                        d="M78.639 3.06628C78.9308 2.12935 80.2569 2.12935 80.5486 3.06628L82.0534 7.89897C82.1836 8.31694 82.5704 8.60167 83.0082 8.60167H87.9654C88.9238 8.60167 89.3333 9.81955 88.5696 10.3986L84.4869 13.4938C84.1512 13.7482 84.011 14.1858 84.1362 14.5879L85.6782 19.5401C85.9675 20.4689 84.8946 21.222 84.1193 20.6343L80.198 17.6614C79.8407 17.3905 79.3469 17.3905 78.9897 17.6614L75.0683 20.6343C74.2931 21.222 73.2202 20.4689 73.5094 19.5401L75.0514 14.5879C75.1766 14.1858 75.0364 13.7482 74.7008 13.4938L70.6181 10.3985C69.8544 9.81955 70.2638 8.60167 71.2222 8.60167H76.1795C76.6172 8.60167 77.0041 8.31694 77.1342 7.89897L78.639 3.06628Z"
                                        fill="#FFD166" />
                                </g>
                                <g filter="url(#filter4_d_3561_414)">
                                    <path
                                        d="M99.6576 2.92705C99.9569 2.00574 101.26 2.00574 101.56 2.92705L103.179 7.91069C103.313 8.32271 103.697 8.60167 104.13 8.60167H109.37C110.339 8.60167 110.742 9.84129 109.958 10.4107L105.719 13.4907C105.368 13.7454 105.221 14.1968 105.355 14.6088L106.975 19.5924C107.274 20.5137 106.219 21.2799 105.436 20.7105L101.196 17.6304C100.846 17.3757 100.371 17.3757 100.021 17.6304L95.7815 20.7105C94.9978 21.2799 93.9433 20.5137 94.2427 19.5924L95.8619 14.6088C95.9958 14.1968 95.8491 13.7454 95.4987 13.4907L91.2593 10.4107C90.4756 9.84129 90.8784 8.60167 91.8471 8.60167H97.0872C97.5204 8.60167 97.9044 8.32271 98.0383 7.91069L99.6576 2.92705Z"
                                        fill="#FFD166" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_3561_414" x="0.683594" y="2.23608" width="27.5273"
                                        height="26.6699" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_3561_414" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3561_414"
                                            result="shape" />
                                    </filter>
                                    <filter id="filter1_d_3561_414" x="22.2227" y="2.23608" width="27.5273"
                                        height="26.6699" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_3561_414" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3561_414"
                                            result="shape" />
                                    </filter>
                                    <filter id="filter2_d_3561_414" x="43.7656" y="2.23608" width="27.5273"
                                        height="26.6699" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_3561_414" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3561_414"
                                            result="shape" />
                                    </filter>
                                    <filter id="filter3_d_3561_414" x="66.2188" y="2.36353" width="26.75"
                                        height="26.4785" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_3561_414" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3561_414"
                                            result="shape" />
                                    </filter>
                                    <filter id="filter4_d_3561_414" x="86.8438" y="2.23608" width="27.5273"
                                        height="26.6699" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_3561_414" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3561_414"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>

                        </div>
                    </div>

                </div>
            </div>
            <!--end::Table-->
        </div>
        <!--end::Card body-->
    </div>
    <!--end::Card-->
    <!--begin::Modals-->
    <!--begin::Modal - Customers - Add-->

    <!--end::Modal - Customers - Add-->
    <!--begin::Modal - Adjust Balance-->

    <!--end::Modal - New Card-->
    <!--end::Modals-->
</div>
<!--end::Content container-->

<div class="modal fade" id="ajouter" tabindex="-1" aria-hidden="true">
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-650px">
        <!--begin::Modal content-->
        <div class="modal-content pt-5  pb-15">
            <!--begin::Modal header-->
            <div class="modal-header">
                <!--begin::Modal title-->
                <h2 class="fw-bold">Ajouter question</h2>
                <!--end::Modal title-->
                <!--begin::Close-->
                <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary"
                    data-bs-dismiss="modal" aria-label="Close">
                    <i class="ki-duotone ki-cross fs-1">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                </div>
                <!--end::Close-->
            </div>
            <!--end::Modal header-->
            <!--begin::Modal body-->
            <div class="modal-body mx-5" [formGroup]="questionForm">
                <div class="bloc-input mb-5">
                    <label for="nom" class="mb-2">Ajouter question</label>
                    <input type="text" formControlName="question" name="question" id="question"
                        class="form-control mb-3">
                </div>
                <div class="bloc-input mb-5">
                    <label for="bloc" class="mb-2">Bloc</label>
                    <ng-select formControlName="chapter_eval_id" [items]="chapitreList" bindLabel="name" bindValue="id" [notFoundText]="'Aucun élément trouvé'"
                        [placeholder]="'Sélectionner un chapitre'" autoComplete></ng-select>
                </div>
                <div class="choose mb-5">
                    <span>Type de réponse</span>
                    <div class="form-check form-check-custom form-check-solid">
                        <input class="form-check-input" type="radio" formControlName="typeResponse" value="1"
                            id="noteRadio" />
                        <label class="form-check-label" for="noteRadio">
                            Note / 5
                        </label>
                    </div>

                    <div class="form-check form-check-custom form-check-solid">
                        <input class="form-check-input" type="radio" formControlName="typeResponse" value="2"
                            id="commentRadio" />
                        <label class="form-check-label" for="commentRadio">
                            Commentaire
                        </label>
                    </div>
                </div>
            </div>
            <div class="card-footer mx-5">
                <div class="actions">
                    <a href="#" class="annuler" data-bs-dismiss="modal" aria-label="Close">Annuler</a>
                    <a class="confirmer" (click)="createQuestion()">Confirmer</a>
                </div>
            </div>
            <!--end::Modal body-->
        </div>
        <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
</div>